import asyncResults from '@/api/modules/async-results'
import { AppHolder } from '@/utils/app-holder'
import { deepCopy } from '@/utils/deep-copy'

import { RESET_MODULE } from '@/store/mutation-types'

const getDefaultState = () => {
  return {
    requests: []
  }
}

const state = getDefaultState()

const deleteRequestId = (state, resultId) => {
  state.requests = state.requests.filter(request => request.resultId !== resultId)
}

const existRequest = (state, resultId) => {
  return state.requests.find(request => request.resultId === resultId)
}

const actions = {
  fetchAsyncResults (context, resultId) {
    return asyncResults.fetchAsyncResults(resultId)
      .then(data => {
        const { mutationId } = context.state.requests.find(request => request.resultId === resultId) || {}
        context.commit('setRequestValue', { data, mutationId, resultId })
      })
  },

  async waitingResult (context, resultId) {
    context.commit('addRequestWaiting', { resultId })

    while (true) {
      await new Promise(resolve => setTimeout(resolve, 500));

      const request = existRequest(context.state, resultId)
      if (request.data) {
        return deepCopy(request.data)
      }
    }
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  addRequestWaiting (state, newRequest) {
    const { resultId } = newRequest
    const existRequest = state.requests.find(request => request.resultId === resultId && !request.mutationId)

    if (!existRequest) {
      state.requests.push(newRequest)
    }
  },

  setRequestValue (state, { mutationId, data, resultId }) {
    const request = existRequest(state, resultId)

    if (mutationId) {
      AppHolder.store.dispatch(mutationId, data)
      deleteRequestId(state, resultId)
    } else if (request) {
      request.data = data
    } else {
      state.requests.push({ resultId, data, mutationId })
    }
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
